import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./static/css/homepage.css";

import * as serviceWorker from "./serviceWorker";
import { WalletChatProvider, WalletChatWidget } from "react-wallet-chat";

ReactDOM.render(
  <React.StrictMode>
    <WalletChatProvider>
      <App />
      <WalletChatWidget />
    </WalletChatProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
